import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {updatePersonalDetailsApi} from "../../API/API"

function* updatePersonalDetailsSaga(params) {
    try {
        const response = yield call(updatePersonalDetailsApi, params); 
        yield put({type: types.UPDATE_PERSONAL_DETAILS_SUCCESS, payload: response.data});
      }
      catch (error) {
        yield put({type: types.UPDATE_PERSONAL_DETAILS_FAILURE, error});
    }
}

export function* watchUpdatePersonalDetailsSaga() {
    yield takeEvery(types.UPDATE_PERSONAL_DETAILS_REQUESTED, updatePersonalDetailsSaga);
}